/**
 * iOS Integration Initializer
 *
 * Initializes iOS WebKit message handlers and navigation tracking.
 * Automatically tracks navigation events and enables WebView communication.
 */

import { useIOSRouterIntegration } from "../lib/ios-navigation-handler";

export function IOSIntegrationInitializer() {
	// Automatically track navigation events in iOS WebView
	useIOSRouterIntegration();

	// Note: useIOSNavigationHandler is opt-in and should be enabled
	// only if the iOS app needs to intercept link clicks.
	// Uncomment and enable if needed:
	// useIOSNavigationHandler(true);

	return null;
}
